import withStyles from '@mui/styles/withStyles';
import React from "react";
import Avatar from "@mui/material/Avatar";
import * as PropTypes from "prop-types";
import classNames from "classnames";
import Badge from "@mui/material/Badge";
import {get} from 'lodash';
import {getPartner} from "common/helpers";
import config from "common/config";
import {color, font, type} from "common/tokens";

const styles = theme => ({
  ListMemberWrapper: {
    display: 'flex',
    borderBottom: `1px solid ${color.DIVIDER}`,
    padding: '14px 16px',
    alignItems: 'center',
    cursor: 'pointer',
    transition: 'background 120ms ease-out',
    '&:hover': {
      background: color.SURFACE_MUTED,
    },
  },
  // The open conversation is tinted rather than outlined, so the list reads as
  // one column with a position in it.
  selectedRow: {
    background: color.PURPLE_TINT,
    '&:hover': {
      background: color.PURPLE_TINT,
    },
  },
  mediumAvatar: {
    width: 48,
    height: 48
  },
  smallAvatar: {
    width: 32,
    height: 32
  },
  groupAvatar: {
    width: 34,
    height: 34
  },
  name: {
    marginLeft: 12,
    ...type.sessionTitle,
    fontWeight: font.SEMIBOLD,
    color: color.TEXT,
    textTransform: 'capitalize',
  },
  nameUnread:{
    fontWeight: font.BOLD,
  },
  // The last message under the name, the way every chat list does it.
  preview: {
    ...type.meta,
    fontWeight: font.REGULAR,
    color: color.TEXT_MUTED,
    marginLeft: 12,
    marginTop: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  unreadMessageCount: {
    backgroundColor: color.ACCENT,
    color: color.ON_ACCENT,
    fontSize: 14,
    fontWeight: 'bold',
    padding: '2px 8px',
    borderRadius: '50%',
    marginLeft: 'auto',
  },
  unreadTaggedMessageIcon: {
    backgroundColor: '#E0B334',
    color: '#fff',
    fontSize: 14,
    fontWeight: 'bold',
    padding: '1px 5px',
    borderRadius: '60%',
    marginRight: 2,
  },
  groupAvatarCount: {
    backgroundColor: '#000',
    color: '#fff',
    fontSize: 14,
    fontWeight: 'bold',
  },
  badgePosition: {
    right: '0%',
    bottom: '-8%'
  },
  groupWrapper:{
    padding:'0px 0px 18px 0px',
    width:48
  },
  searchChannelTitle: {
    color: '#000000',
    fontWeight: 500,
    fontSize: 14
  },
  searchResult: {
    borderBottom: 'none',
    padding: '4px 16px',
  },
  selectedSearchedChannel: {
    color: '#E0B334',
  },
  highlight: {
    color: "#3E3E3E",
    fontWeight: 600,
    fontSize: 12,
  },
});


const ListMember = ({
                      classes, isGroup, members, myId, channelName, channelId, onItemClick,
                      unreadMessageCount, isSelected, isSearch, setSelectedTab, unreadMessageData, botUsers
                    }) => {
  const { AI_ROLE_TYPE } = config;
  const partner = !isGroup ? getPartner(members,myId) : "";

  const isUnread = unreadMessageCount > 0;
  const chatBotUser = (botUsers?.length || 0) !== 0
  ? botUsers.find(botUser => botUser.roleType === AI_ROLE_TYPE)
  : null;
  const isAIChannel = chatBotUser && members?.some(member => member.userId === chatBotUser.userId);

  return (
    <div className={classNames(classes.ListMemberWrapper, isSearch && classes.searchResult, isSelected && !isSearch && classes.selectedRow)}
         onClick={() => {
          onItemClick(channelId, 1)
          setSelectedTab && setSelectedTab('channels')
        }}>
      <div>
        {isGroup &&
        <div className={classes.groupWrapper}>
          <Badge
            overlap="circular"
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            classes={{
              anchorOriginBottomRightCircular: classes.badgePosition
            }}
            badgeContent={<Avatar alt="" src={get(members,"[0].displayPicture")}  className={classes.groupAvatar}/>}
          >
            <Avatar alt=""  className={classes.smallAvatar} classes={
              {root: classes.groupAvatarCount}
            }>+{members.length - 2}</Avatar>
          </Badge>
        </div>
        }
        {!isGroup && <Avatar alt={get(partner, "userFullName")} src={get(partner,'displayPicture')} className={classes.mediumAvatar}/>}
      </div>
      {!isGroup &&
      <div
        className={classNames(classes.name, isUnread && classes.nameUnread, isSearch && classes.searchChannelTitle, (isSearch && isSelected) && classes.selectedSearchedChannel)}>{isAIChannel ? channelName : get(partner, "userFullName")}</div>}
      {isGroup &&
      <div className={classNames(classes.name, isUnread && classes.nameUnread, isSearch && classes.searchChannelTitle, (isSearch && isSelected) && classes.selectedSearchedChannel)}>{channelName}</div>}
      <div style={{ display: 'flex', marginLeft: 'auto' }}>
        {isUnread && unreadMessageData?.is_tagged && <div
          className={classes.unreadTaggedMessageIcon}
        >@</div>
        }
        {isUnread &&
        <div className={classes.unreadMessageCount}>{unreadMessageCount}</div>
        }
      </div>
    </div>
  );
};

export default withStyles(styles)(ListMember);


ListMember.propTypes = {
  isGroup: PropTypes.bool,
  isUnread: PropTypes.bool,
  isSelected: PropTypes.bool,
  channelId: PropTypes.string,
  onItemClick: PropTypes.func,
  unreadMessageCount: PropTypes.number
};

ListMember.defaultProps = {
  isGroup: false,
  isUnread: false,
  channelId: ''
};
